interface Information {
  emailMaster: string;
  companyName: string;
  segment: string;
  localization: string;
  ph: string;
  dth: string;
  isMultiple: boolean;
  id: string;
}

interface Address {
  country: string;
  voivodship: string;
  city: string;
  street: string;
  buildingNo: number;
  apartmentNo: number;
  post: string;
  postCode: string;
}
export enum ContractorState {
  EXISTS_ECOM = "EXISTS_ECOM",
  EXISTS_ERP = "EXISTS_ERP",
  NOT_EXISTS = "NOT_EXISTS",
}

export interface ContractorExistResponse {
  state: ContractorState;
  information: Information;
}

export type ContractorExistTransformResponse = Information & {
  state: ContractorState;
  contractorNip: string;
};

export interface ContractorNipReportResponse {
  reportId: string;
  companyId: string;
  status: string;
  companyName: string;
  address: Address;
}


export interface ContractorSubmittalRequest {
  contractorNip: string;
  existsInErp: boolean;
  companyName: string;
  city: string;
  street: string;
  streetNumber: number;
  zipCode: string;
  businessArea: string;
  purchaseVolume: string;
  companyBranch: string;
  contactPerson: string;
  phoneNumber: number;
  email: string;
  multiple: boolean;
}